"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var state = {
    sizeState: { name: '15cm', size: 1 },
    selectedItem: [],
    id: null,
    name: null,
};
exports.default = state;
